
    var UNDEF;

    /**
     */
    function isUndef(val){
        return val === UNDEF;
    }
    module.exports = isUndef;




//////////////////
// WEBPACK FOOTER
// ./~/mout/lang/isUndefined.js
// module id = 1612
// module chunks = 0 1 2